"use strict";

define('rs/models/notification.manager',['rs/models/abstract', 'evisions/promise', 'jquery'], function (AbstractModel, Promise, $) {
  var NotificationManager = AbstractModel.extend({
    properties: ['notifications', 'count', 'help'],
    initialize: function initialize(options) {
      this._super.apply(this, arguments);
      this.options = _.extend({}, this.options, options);
      this.setNotifications([]);
      if (options.start === true) {
        this.start();
      }
    },
    start: function start() {
      return this.refresh().bind(this).tap(function () {
        this._initialized = true;
      });
    },
    refresh: function refresh() {
      return Promise.resolve(this._requestItems()).bind(this).tap(this.didReceiveNewItems);
    },
    next: function next() {
      return Promise.resolve(this._requestItems()).bind(this).tap(function (items) {
        this.didReceiveNewItems(items, true);
      });
    },
    refreshCount: function refreshCount() {
      this.setCount(this._getCount());
    },
    didReceiveNewItems: function didReceiveNewItems(items, concat) {
      var i = 0,
        status = 0,
        item = null,
        mappedItems = null,
        newItems = [],
        old = this.getNotifications(),
        ids = _.pluck(old, 'id'),
        len = items ? items.length : 0;
      mappedItems = _.map(items, this.mapItemToNotification, this);
      if (concat === true) {
        mappedItems = this.getNotifications().concat(mappedItems);
      }
      this.setNotifications(mappedItems);
      this.refreshCount();
      items = this.getNotifications();
      len = items.length;
      for (i = 0; i < len; i++) {
        if (_.indexOf(ids, items[i].id) < 0) {
          newItems.push(items[i].item);
        }
      }
      if (newItems.length && this._initialized) {
        this.trigger('new', newItems);
      }
    },
    mapItemToNotification: function mapItemToNotification(item) {
      var n = {
        id: this._getIdFromItem(item),
        item: item,
        unread: this._getUnreadFromItem(item),
        title: this._getTitleFromItem(item),
        date: this._getDateFromItem(item),
        body: this._getBodyFromItem(item),
        urgent: this._getUrgencyFromItem(item),
        template: this._getTemplateForItem(item),
        selectable: this._getSelectable(item),
        canDelete: this._canDelete(item)
      };
      return n;
    },
    notificationWasSelected: function notificationWasSelected(notification) {},
    _getCount: function _getCount() {
      return this.getNotifications().length;
    },
    _requestItems: function _requestItems() {
      return [];
    },
    _getIdFromItem: function _getIdFromItem(item) {
      return item.id;
    },
    _getTitleFromItem: function _getTitleFromItem(item) {
      return item.title;
    },
    _getDateFromItem: function _getDateFromItem(item) {
      return item.date;
    },
    _getBodyFromItem: function _getBodyFromItem(item) {
      return item.body;
    },
    _getUnreadFromItem: function _getUnreadFromItem(item) {
      return item.unread;
    },
    _getUrgencyFromItem: function _getUrgencyFromItem(item) {
      return false;
    },
    _getTemplateForItem: function _getTemplateForItem() {
      return null;
    },
    _getSelectable: function _getSelectable() {
      return false;
    },
    _canDelete: function _canDelete() {
      return false;
    }
  });
  return NotificationManager;
});

